import React from 'react';
import { Note, type NoteProps } from './NotePrimitives';

export const WarningNote = ({
  size,
  className,
  children,
}: React.PropsWithChildren<Pick<NoteProps, 'size' | 'className'>>) => (
  <Note variant="warning" size={size} className={className}>
    {children}
  </Note>
);
